import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ColorLogoMobile from '@dls/assets/images/logo_singtel@2x.png';
import ColorLogoDesktop from '@dls/assets/images/logo_singtel@3x.png';
import WhiteLogo from '@dls/assets/images/logo_singtel_white@3x.png';
import media from '../../helpers/media';
import { isIFrame } from '../../helpers/utils';
import { useRecoilValue } from 'recoil';
import { aemConfigState, themeNameState } from '../../index';

const HeaderWrapper = styled.div`
  text-align: center;
  
   &.gomo-theme {
      margin: 40px 0px;
   }

  ${media.sm`
    margin-top: 24px;
    margin-bottom: 24px;
    
    &.gomo-theme {
      margin-top: 100px;
    }
  `}
`;

const LogoImage = styled.img`
  max-width: 120px;
  max-height: 120px;

  &[data-screen='desktop'] {
    display: none;
  }

  ${media.sm`
    &[data-screen='mobile'] {
      display: none;
    }
    &[data-screen='desktop'] {
      display: block;
    }
  `}
  
  &.logo-gomo-theme {
    max-width: 100%;
  }
`;

export default function Header() {
  const [isIframe, setIsIFrame] = useState(false);
  const aemConfig = useRecoilValue(aemConfigState);
  const themeName = useRecoilValue(themeNameState);

  useEffect(() => {
    setIsIFrame(isIFrame());
  }, []);

  if (isIframe) return null;

  // Resolve logos based on theme and mode. For GOMOSMB use the static SVG for both sizes.
  const resolveLogos = (themeName?: string, mode?: string) => {
    if (themeName === 'GOMOSMB') {
      const gLogo = '../gomosmb.svg'; // served from static folder root (absolute path)
      return { desktop: gLogo, mobile: gLogo };
    }
    const desktop = mode === 'dark' ? WhiteLogo : ColorLogoDesktop;
    return { desktop, mobile: ColorLogoMobile };
  };

  const { desktop, mobile } = resolveLogos(themeName, aemConfig.mode);
  // Cast styled component to any to silence TS attribute inference issues for img props.
  const Img = LogoImage as any;

  return (
    <HeaderWrapper className={themeName === 'GOMOSMB' ? 'gomo-theme' : ''}>
      <Img data-screen="desktop" src={desktop} alt="Logo" className={themeName === 'GOMOSMB' ? 'logo-gomo-theme' : ''}/>
      <Img data-screen="mobile" src={mobile} alt="Logo" className={themeName === 'GOMOSMB' ? 'logo-gomo-theme' : ''}/>
    </HeaderWrapper>
  );
}